import React, { useContext, useState } from 'react';
import { MyContext } from '../../../context';
import DropDownV2 from '../../../global/ui/DropDownV2';
import { showToast } from '../../../utils';
interface Props {
    onClose: () => void;
    onDone: (data: any, locationId: any) => void;
    locationData?: any
}

const AsignLocationToProd: React.FC<Props> = ({ onClose, onDone, locationData }) => {

    const { companies } = useContext(MyContext);

    const [selectedData, setSelectedData] = useState<any>(null)

    const handleApply = () => {
        if (!selectedData?.id) {
            showToast('Please add at least one production', 'error');
            return
        }
        onDone?.(selectedData, locationData?.id);
    }

    return (
        <div className="lc-modal-overlay">
            <div
                style={{ textAlign: 'left' }}
                className="lc-modal"
            >
                <button
                    type="button"
                    className="lc-modal__close"
                    onClick={onClose}
                >
                    <img
                        src="/assets/images/dismiss.svg"
                        alt="close"
                    />
                </button>

                <div className="lc-modal__icon">
                    <img
                        src="/assets/images/badge-check.svg"
                        alt="location created"
                    />
                </div>

                <h2 className="lc-modal__title">
                    Select the production to add to
                </h2>

                <div style={{ width: '100%' }} className="personal-info__field">
                    <DropDownV2
                        isClearable={false}
                        data={companies}
                        onSelect={setSelectedData}
                        selectedItems={selectedData}
                        placeholder='Please select production'
                    />
                </div>

                <div className="lc-modal__buttons">
                    <button
                        style={{ width: '200px' }}
                        type="button"
                        className="lc-modal__btn lc-modal__btn--primary"
                        onClick={handleApply}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AsignLocationToProd;